import type { ReactElement, ReactNode } from 'react';
import styles from './Stat.module.scss';

/** Показатель: подпись, крупное значение и пояснение мелко. */
export function Stat({ label, value, hint }: { label: string; value: ReactNode; hint?: ReactNode }): ReactElement {
  return (
    <div className={styles.stat}>
      <span className={styles.label}>{label}</span>
      <strong className={styles.value}>{value}</strong>
      {hint ? <span className={styles.hint}>{hint}</span> : null}
    </div>
  );
}

/** Сетка показателей: две колонки на телефоне, дальше — сколько поместится. */
export function StatGrid({ children }: { children: ReactNode }): ReactElement {
  return <div className={styles.grid}>{children}</div>;
}
